


















































































































import Vue from 'vue';
import AOS from 'aos';
import 'aos/dist/aos.css';
import CookieLaw from 'vue-cookie-law';

AOS.init({
	once: true,
});

export default Vue.extend({
	methods: {
		removeBodyClass() {
			document.body.classList.remove('nav-active');
		},
	},
	data() {
		return {
			routes: [{
					text: 'Tjenester',
					to: '/vare-tjenester',
				},
				{
					text: 'Om oss',
					to: '/om-oss',
				},
				{
					text: 'Blogg',
					to: '/blogg',
				},
				{
					text: 'Kontakt oss',
					to: '/kontakt-oss',
				},
			],
		};
	},
	mounted() {
		(() => {
			// Navigation
			const app = () => {
				let body: any;
				let menu: any;
				init();

				function init() {
					body = document.querySelector('body');
					menu = document.querySelector('.menu-icon');
					applyListeners();
				}
				function applyListeners() {
					menu.addEventListener('click', () => {
						return toggleClass(body, 'nav-active');
					});
				}
				function toggleClass(element: any, stringClass: any) {
					if (element.classList.contains(stringClass)) {
						element.classList.remove(stringClass);
					} else {
						element.classList.add(stringClass);
					}
				}
			};
			app();
		})();
	},
	metaInfo: {
		titleTemplate: 'Kreatif.no - %s',
	},
	components: {
		CookieLaw,
	},
});

